/* eslint-disable jsx-a11y/alt-text */
import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import {BsCheck} from 'react-icons/bs'

function AnswerType2({ answers, onChange, isAnswer, help }) {
  const [selected, setSelected] = useState([]);

  const onSelected = (id) => {
    const tmp = [...selected];
    if (!tmp.includes(id)) {
      setSelected([...tmp, id]);
    } else {
      setSelected(tmp.filter((_i) => _i != id));
    }
  };

  useEffect(() => {
    setSelected([]);
  }, [answers]);

  useEffect(() => {
    if (selected.length) {
      onChange(selected);
    } else {
      onChange('');
    }
  }, [selected]);

  return answers.map((item) => (
    <div
      className={classNames('item', {
        active: selected.includes(item._id),
        isCorrect: isAnswer && help &&  item.isTrue && selected.includes(item._id),
        notCorrect: isAnswer && help && !item.isTrue && selected.includes(item._id),
      })}
      onClick={() => onSelected(item._id)}
      key={'answer_' + item._id}
    >
      <div className={'answerTrue'} onClick={() => onSelected(item._id)}>
        <BsCheck size="20" color="white" />
      </div>
      {item.url && <img src={item.url} />}
      {!item.url && <div className={'title'}>{item.text}</div>}
    </div>
  ));
}

export default AnswerType2;



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/QuestionMultyView/components/Question/components/Answers/components/AnswerType2/AnswerType2.jsx